<div
  class="z-[999] fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center"
>
  <div class="bg-white rounded-2xl max-w-[80%] w-[40%] pb-[15px] flex flex-col">
    <!-- Header con titolo centrato e bottone a destra -->
    <div class="flex justify-between items-center relative px-4 py-6">
      <!-- Titolo centrato assolutamente -->
      <h2
        class="text-[1.1rem] xl:text-[1.3rem] 2xl:text-[1.5rem] 3xl:text-[1.6rem] 4xl:text-[1.7rem] font-bold text-dimot-1 absolute left-1/2 transform -translate-x-1/2"
      >
        Contattaci
      </h2>

      <!-- Bottone di chiusura allineato a destra -->
      <button (click)="oncloseModal()" class="font-bold cursor-pointer ml-auto">
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.4375 21.5625L21.5625 8.4375M21.5625 21.5625L8.4375 8.4375"
            stroke="#6B7280"
            stroke-width="0.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <div class="container">
      <div class="asana-embed-container">
        <link
          rel="stylesheet"
          href="https://form.asana.com/static/asana-form-embed-style.css"
        /><iframe
          class="asana-embed-iframe"
          src="https://form.asana.com/?k=zwnbWIy01b2tjcObsf61VA&d=1208491828593110&embed=true"
        ></iframe>
      </div>
      <!--<div class="asana-embed-container">
                <link rel="stylesheet" href="https://form.asana.com/static/asana-form-embed-style.css"/>
                <iframe class="asana-embed-iframe" src="https://form.asana.com/?k=hk0kHKKNC10uUa_tJ7zaBQ&d=1208491828593110&embed=true"></iframe>
            </div>-->
    </div>
  </div>
</div>
